import { FC } from 'react';
import styles from './ReviewsList.module.scss';
import ReviewCard from '../review-card/ReviewCard';
import { IReviews, IReviewsData } from '@/interfaces/reviews.interface';

interface IReviewsList {
  reviews: IReviews;
  isBlogPage?: boolean;
}

const ReviewsList: FC<IReviewsList> = ({ reviews, isBlogPage }) => {
  return (
    <div className={`${styles.reviewsList}`}>
      {reviews.data.map((review: IReviewsData) => (
        <ReviewCard key={review.id} name={review.name} message={review.message} date={review.created_at} isBlogPage={isBlogPage} />
      ))}
    </div>
  );
};

export default ReviewsList;
